import { Text, View } from "@react-pdf/renderer";
import { formatCurrency } from "../../Utils/formatCurrency";
import CfmReportStyles from "../../CfmReportStyles";
import PageWrapper from "../../Components/PageWrapper";

const columns = [
  { key: "age", label: "Age" },
  { key: "fundValue", label: "Fund Value" },
  { key: "contribution", label: "Contribution" },
  { key: "grossRegularIncome", label: "Gross Regular Income" },
  { key: "taxedDrawdown", label: "Drawdown" },
  { key: "tflsWithdrawal", label: "TFLS" },
  { key: "phasedTfc", label: "Phased TFC" },
  { key: "adhocContribution", label: "Ad-Hoc Contribution" },
  { key: "adhocWithdrawal", label: "Ad-Hoc Withdrawal" },
];

const CHUNK_SIZE = 18;

const PensionResultsSection = ({
  pensionResults,
  details,
  primaryColor,
  tradingName,
  footerText,
}) => {
  if (!pensionResults?.length) return null;

  // console.log("PensionResultsSection - pensionResults:", pensionResults);

  const styles = CfmReportStyles(primaryColor);

  return (
    <>
      {pensionResults.map((entry, idx) => {
        const funds = entry.pensionFunds;
  const personIndex = pensionResults
    .slice(0, idx)
    .filter((e) => e.name === entry.name).length;
  const displayIndex = personIndex + 1;

  // determine active columns
  const activeColumns = columns.filter((col) => {
    if (col.key === "age") return true;
    return funds.some((fund) => fund[col.key] !== "£0.00");
  });

  const omittedColumns = columns
    .filter((col) => !activeColumns.includes(col))
    .map((col) => col.label);

  // console.log(
  //   `PensionResultsSection - columns omitted for ${entry.name}:`,
  //   omittedColumns.length ? omittedColumns.join(", ") : "None"
  // );

  // split to page chunks
  const chunks = [];
  const matchedPerson = details.find((p) => p.name === entry.name);
  const retirementAge = Number(matchedPerson?.retirementAge);

  for (let i = 0; i < funds.length; i += CHUNK_SIZE) {
    chunks.push(funds.slice(i, i + CHUNK_SIZE));
  }

  return chunks.map((chunk, chunkIndex) => (
    <PageWrapper
      key={`${entry.name}-${chunkIndex}`}
      size="A4"
      style={styles.page}
      orientation="landscape"
      primaryColor={primaryColor}
      tradingName={tradingName}
      footerText={footerText}
      headerTitle={
        chunkIndex === 0
          ? `${entry.name} - Pension ${displayIndex}: Growth Overview`
          : `${entry.name} - Pension ${displayIndex}: Growth Overview (continued)`
      }
      headerSubText={`${entry.type}`}
    >
      <View style={{ padding: 16 }}>
        <View style={styles.tableHeader}>
          {activeColumns.map((col) => (
            <Text
              key={col.key}
              style={[
                styles.tableCell,
                styles.tableHeaderText,
                col.key === "age" && styles.ageCell,
              ]}
            >
              {col.label}
            </Text>
          ))}
        </View>

        {chunk.map((fund, i) => {
          const isRetirementAge = Number(fund.age) === retirementAge;
          const isEvenRow = i % 2 === 0;

          return (
            <View
              key={i}
              style={[
                styles.tableRow,
                isEvenRow && styles.altRow,
                isRetirementAge && styles.highlightRow,
              ]}
            >
              {activeColumns.map((col) => (
                <Text
                  key={col.key}
                  style={[
                    styles.tableCell,
                    col.key === "age" && styles.ageCell,
                  ]}
                >
                  {col.key === "age"
                    ? fund[col.key]
                    : formatCurrency(fund[col.key])}
                </Text>
              ))}
            </View>
          );
        })}
      </View>
    </PageWrapper>
  ));
      })}
    </>
  );
};

export default PensionResultsSection;
